import { render, staticRenderFns } from "./TurnComponent.vue?vue&type=template&id=f646b4bc&"
import script from "./TurnComponent.vue?vue&type=script&lang=js&"
export * from "./TurnComponent.vue?vue&type=script&lang=js&"
import style0 from "./TurnComponent.vue?vue&type=style&index=0&id=f646b4bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports